import React from "react";

const SecondColumn = props => {
	return (
		<div className="col-md-4 col-12 p-3 second-column">{props.children}</div>
	);
};
export default SecondColumn;
